// const response = await axiosInstance.get('/project/allProjects', {
//     headers: {
//       'x-company-id': '67ce66294f28f85e4ff91e2c'
//     }
//   });




import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from 'js-cookie'
import axiosInstance from "../../Component/axiosInstance";


const getAllprojects = createAsyncThunk('display', async (projectid, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/project/allProjects', {
            headers: {
              'x-company-id': '67ce66294f28f85e4ff91e2c'
            }
          });
        // console.warn("This is projects ",response.data)
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
});


const getAllprojectsSlice = createSlice({
    name: 'getallprojects',
    initialState: {
        loading: false,
        error: null,
        data: null,
        projects:null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllprojects.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.data = null;
                state.isSuccess = false;
                state.isError = false;
            })
            .addCase(getAllprojects.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.projects = action.payload;
                // console.log(`this is payload ${action.payload}`);
                state.isSuccess = true;
                state.isError = false;
            })
            .addCase(getAllprojects.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.data = null;
                state.isError = true;  // Fixed issue here
                state.isSuccess = false;
            });
    }
})


export   { getAllprojects}  ;
export default getAllprojectsSlice.reducer;